/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetDeviceIntegrationConfigSecurity = {
  apikeyHeaderGramKey?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type GetDeviceIntegrationConfigRequest = {
  /**
   * Provider identifier (e.g. jamf, kandji, drata, vanta).
   */
  provider: string;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type GetDeviceIntegrationConfigSecurity$Outbound = {
  "apikey_header_Gram-Key"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const GetDeviceIntegrationConfigSecurity$outboundSchema: z.ZodMiniType<
  GetDeviceIntegrationConfigSecurity$Outbound,
  GetDeviceIntegrationConfigSecurity
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function getDeviceIntegrationConfigSecurityToJSON(
  getDeviceIntegrationConfigSecurity: GetDeviceIntegrationConfigSecurity,
): string {
  return JSON.stringify(
    GetDeviceIntegrationConfigSecurity$outboundSchema.parse(
      getDeviceIntegrationConfigSecurity,
    ),
  );
}

/** @internal */
export type GetDeviceIntegrationConfigRequest$Outbound = {
  provider: string;
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const GetDeviceIntegrationConfigRequest$outboundSchema: z.ZodMiniType<
  GetDeviceIntegrationConfigRequest$Outbound,
  GetDeviceIntegrationConfigRequest
> = z.pipe(
  z.object({
    provider: z.string(),
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
    });
  }),
);

export function getDeviceIntegrationConfigRequestToJSON(
  getDeviceIntegrationConfigRequest: GetDeviceIntegrationConfigRequest,
): string {
  return JSON.stringify(
    GetDeviceIntegrationConfigRequest$outboundSchema.parse(
      getDeviceIntegrationConfigRequest,
    ),
  );
}
